import * as React from "react";

import { cn } from "@/lib/chillnn/cn";

import { Input } from "./input";

import type { InputProps } from "./input";

export interface InputNumberProps extends InputProps {
	needsDecimal?: boolean;
}

const InputNumber = React.forwardRef<HTMLInputElement, InputNumberProps>(({ needsDecimal = false, ...props }, ref) => {
	const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
		// ホイール操作によるインプットがあった場合フォーカスを外す
		e.currentTarget.blur();
		e.stopPropagation();
	};

	return (
		<Input
			type={"number"}
			step={needsDecimal ? "0.000001" : "1"}
			className={cn("hidden-spin-button", props.className)}
			onWheel={handleWheel}
			{...props}
			ref={ref}
		/>
	);
});

InputNumber.displayName = "InputNumber";

export { InputNumber };
